import TextLinkHorizontal from '../../../components/common/card/TextLinkHorizontal'
import { n_lesson_prep } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

type MediaTabPropsType = {
  media: any
  onEnd: any
  checkYoutube: any
  onPlay: any
  onPause: any
  onArticleClick: any
  isMobile?: boolean
}

const MediaTab = ({ media, onEnd, checkYoutube, onPlay, onPause, onArticleClick, isMobile }: MediaTabPropsType) => {
  const { t } = useTranslation()
  return (
    <div className="pb-[16px]">
      {media?.youtubes?.length > 0 && (
        <div className="Title1-20Bd mb-[16px] text-gray-600">{t(n_lesson_prep.complete.related_video)}</div>
      )}
      <div className="mb-[32px] flex flex-col gap-[16px]">
        {media.youtubes?.map((item, i) => (
          <div className="aspect-[16/9]" key={i}>
            <iframe
              width="100%"
              height="100%"
              className="aspect-[16/9]"
              src={`https://www.youtube.com/embed/${item.code}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ))}
      </div>
      {media.articles?.length > 0 && (
        <div className="Title1-20Bd mb-[16px] text-gray-600">{t(n_lesson_prep.complete.related_news)}</div>
      )}
      {media.articles?.map((item, i) => (
        <TextLinkHorizontal item={item} key={i} onClick={onArticleClick} />
      ))}
    </div>
  )
}

export default MediaTab
